import { put, call } from 'redux-saga/effects';

import * as actions from '@actions/vatReturn';
import { downloadVatReturn } from '@api/vatReturn';
import { intl } from '@helpers/intl';
import { toastError } from '@store/notifications';

export const handleDownloadVatReturnRequest = function* ({ payload }) {
  try {
    yield call(downloadVatReturn, payload.standardTemplate);
    yield put(actions.downloadSuccess());
  } catch (error) {
    const { nonFieldErrors } = error?.data || {};
    const errorMessage =
      nonFieldErrors ||
      intl.formatMessage({
        id: 'global.notification.api-error-default',
        defaultMessage: 'An unexpected error occurred, please try again.',
      });

    yield put([
      toastError({
        message: errorMessage,
      }),
      actions.downloadFailure({ error: errorMessage }),
    ]);
  }
};
